export function mergeDeepObj<
  T extends Record<string, any> = Record<string, any>,
  S extends null | Record<string, any> | undefined = Record<string, any>,
>(target: T, source?: S): T {
  // Handle null/undefined source
  if (!source) {
    return target;
  }

  const output = {...target};

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      if (isPlainObject(source[key])) {
        if (!(key in target) || !isPlainObject(target[key])) {
          Object.assign(output, {[key]: source[key]});
        } else {
          // @ts-expect-error: Type T is generic and can only be indexed for reading. We need to write
          output[key] = mergeDeepObj(target[key], source[key]);
        }
      } else {
        Object.assign(output, {[key]: source[key]});
      }
    });
  }

  return output;
}

function getType(value: any): string {
  return Object.prototype.toString.call(value).slice(8, -1);
}

function isPlainObject(value: any): value is Record<string, any> {
  if (getType(value) !== 'Object') {
    return false;
  }

  return (
    value.constructor === Object &&
    Object.getPrototypeOf(value) === Object.prototype
  );
}
